import {
  Tag,
  TagText,
  Text,
  Tooltip,
} from '@alefeducation/ui-elements-library-core';
import React from 'react';
import styled from 'styled-components';

type TagsViewProps = {
  items: string[];
  tooltipId: string;
};

function splitArray<T>(arr: T[]) {
  const firstArray = arr.length < 1 ? [...arr] : arr.slice(0, 1);
  const restArray = arr.slice(1);

  return [firstArray, restArray];
}

const TagsView = (props: TagsViewProps) => {
  const [items, restItems] = splitArray(props.items);

  const renderItemsTags = (items: string[]) =>
    items.map((item) => (
      <Tag key={`item-${item}`} color="lightBlue" padding="thick">
        <TagText>{item}</TagText>
      </Tag>
    ));

  return (
    <StyledTagContainer>
      {renderItemsTags(items)}
      {restItems.length > 0 && (
        <Tooltip
          content={
            <StyledToolTipContent>
              {renderItemsTags(restItems)}
            </StyledToolTipContent>
          }
          id={props.tooltipId}
          position="bottom"
          delayHide={500}
          clickable
        >
          <Text
            variant="body-medium"
            color="interactive.140"
          >{`${restItems.length}+ more`}</Text>
        </Tooltip>
      )}
    </StyledTagContainer>
  );
};

export default TagsView;

const StyledTagContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  column-gap: 8px;
`;

const StyledToolTipContent = styled.div`
  display: flex;
  gap: 10px;
  max-width: 240px;
  padding: 18px 16px;
  flex-wrap: wrap;

  max-height: 200px;
  overflow: auto;
`;
